import InvoiceApiClient from "./base";

// download API
export const invoiceDownloadApi = {
  // Start download process for given year and month
  startDownload: (year, month) => {
    return InvoiceApiClient.post("/download/start", { year, month });
  },

  // Stop ongoing download
  stopDownload: () => {
    return InvoiceApiClient.post("/download/stop");
  },

  // Get download status
  getDownloadStatus: () => {
    return InvoiceApiClient.get("/download/status");
  },

  // Health check for download service
  downloadHealthCheck: () => {
    return InvoiceApiClient.get("/download/health");
  },

  // Get available ZIP files
  getAvailableZips: () => {
    return InvoiceApiClient.get("/download/available_zips");
  },

  // Download a specific zip file by year and month
  getBuchhaltungPreview: (year, month, options = {}) => {
    const { datevLink = "", inventurNetEur = "" } = options;
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
      datev_link: datevLink,
      inventur_net_eur: inventurNetEur,
    });
    return InvoiceApiClient.get(
      `/download/buchhaltung/preview?${params.toString()}`,
    );
  },

  sendBuchhaltung: (payload) => {
    return InvoiceApiClient.post("/download/buchhaltung/send", payload);
  },

  saveBuchhaltungEmailBody: (year, month, body) => {
    return InvoiceApiClient.put("/download/buchhaltung/email-body", {
      year: Number(year),
      month: Number(month),
      body,
    });
  },

  clearBuchhaltungEmailBody: (year, month) => {
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
    });
    return InvoiceApiClient.delete(
      `/download/buchhaltung/email-body?${params.toString()}`,
    );
  },

  downloadBuchhaltungAttachmentsZip: (year, month) => {
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
    });
    return InvoiceApiClient.get(
      `/download/buchhaltung/attachments/zip?${params.toString()}`,
      {
        responseType: "blob",
        headers: { Accept: "application/zip" },
      },
    );
  },

  uploadBuchhaltungReport: (year, month, reportType, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
      report_type: reportType,
    });
    return InvoiceApiClient.post(
      `/download/buchhaltung/reports/upload?${params.toString()}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },

  uploadBankCreditcardReport: (year, month, reportKey, files) => {
    const formData = new FormData();
    const list = Array.isArray(files) ? files : [files];
    list.forEach((file) => {
      formData.append("files", file);
    });
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
      report_key: reportKey,
    });
    return InvoiceApiClient.post(
      `/download/buchhaltung/bank-creditcard/upload?${params.toString()}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },

  getBankCreditcardReports: (year, month) => {
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
    });
    return InvoiceApiClient.get(
      `/download/buchhaltung/bank-creditcard?${params.toString()}`,
    );
  },

  getManualPlatformInvoices: (year, month) => {
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
    });
    return InvoiceApiClient.get(
      `/download/platform-invoices/manual?${params.toString()}`,
    );
  },

  uploadManualPlatformInvoice: (year, month, platform, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
      platform,
    });
    return InvoiceApiClient.post(
      `/download/platform-invoices/manual/upload?${params.toString()}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },

  getFailedInvoices: (year, month) => {
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
    });
    return InvoiceApiClient.get(
      `/download/failed-invoices?${params.toString()}`,
    );
  },

  uploadFailedInvoices: (year, month, files) => {
    const formData = new FormData();
    const list = Array.isArray(files) ? files : [files];
    list.forEach((file) => {
      formData.append("files", file);
    });
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
    });
    return InvoiceApiClient.post(
      `/download/failed-invoices/upload?${params.toString()}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },

  downloadZip: (year, month, options = {}) => {
    const {
      includeShoppingTable = true,
      includePlatforms = true,
      includeReports = true,
      sortPlatformsInFolders = false,
      sortReportsInFolders = false,
      batchShoppingTable = true,
      shoppingTableBatchSize = 300,
    } = options;
    const params = new URLSearchParams({
      year: String(year),
      month: String(month),
      include_shopping_table: String(includeShoppingTable),
      include_platforms: String(includePlatforms),
      include_reports: String(includeReports),
      sort_platforms_in_folders: String(sortPlatformsInFolders),
      sort_reports_in_folders: String(sortReportsInFolders),
      batch_shopping_table: String(batchShoppingTable),
      shopping_table_batch_size: String(shoppingTableBatchSize),
    });
    return InvoiceApiClient.get(`/download/zip?${params.toString()}`, {
      responseType: "blob",
      headers: {
        Accept: "application/zip",
      },
    });
  },
};
